import { fetchUtils } from 'react-admin'

import getSession from './getSession'

export const httpClient = async (url, options = {}) => {
  const session = await getSession()

  const { accessToken: token } = session ?? {}

  if (options.type === 'download') {
    return new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest()
        xhr.onreadystatechange = function () {
          if (this.readyState === 4 && this.status === 200) {
            const blobURL = window.URL.createObjectURL(this.response)
            const anchor = document.createElement('a')
            anchor.download = options.filename
            anchor.href = blobURL
            anchor.click()
          }
        }
        xhr.open('GET', url)
        xhr.setRequestHeader('Authorization', `Bearer ${token}`)
        xhr.responseType = 'blob'
        xhr.send()
        resolve({
          data: {},
        })
      } catch (err) {
        console.error(err)
        reject(err)
      }
    })
  }

  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' })
  }

  options.headers.set('Authorization', `Bearer ${token}`)
  return fetchUtils.fetchJson(url, options)
}
